module.exports = __webpack_public_path__ + "static/thanks-8e20260b915bf8211494223a3c432123.jpg";